import ClientCalling from "../../api/ClientCalling";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

const getFcmToken = async () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    console.log("FCM not supported in this browser");
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    const messaging = getMessaging(app);

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission denied");
      return;
    }

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    if (token) {

      await ClientCalling.setNotificationServer({ token, platform: "web" });
    }

    // Handle FOREGROUND notifications (when app is open)
    onMessage(messaging, (payload) => {
      console.log('Foreground message received:', payload);

      const title = payload.data?.title || payload.notification?.title || "Notification";
      const body = payload.data?.body || payload.notification?.body || "";
      const image = payload.data?.image || payload.notification?.image || null;
      const url = payload.data?.productId
        ? `/list/${payload.data.productId}`
        : payload.data?.redirecturl || "/";

      toast(
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px"
          }}
          onClick={() => {
            window.location.href = url;
            toast.dismiss(); // Close toast on click
          }}
        >
          {image && (
            <img
              src={image}
              alt="notification"
              style={{
                width: 50,
                height: 50,
                objectFit: "cover",
                borderRadius: "4px",
                flexShrink: 0
              }}
            />
          )}
          <div style={{ flex: 1 }}>
            <strong style={{ display: "block", marginBottom: "4px" }}>{title}</strong>
            <div style={{ fontSize: "14px", color: "#666" }}>{body}</div>
          </div>
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true
        }
      );
    });

  } catch (err) {
    console.error("Error getting FCM token:", err);
  }
};

export default getFcmToken;